import React, { PropsWithChildren } from 'react';
import { Tabs, Direction } from '../../../Tabs';
import { useAppContext } from '../../../../../contexts/AppContext/AppContext';
import { Breakpoints } from '../../../../../types/Breakpoints';
import { FetchingData, HidingStrategy } from '../../../Tabs/Context';

type MultiStepFormProps = PropsWithChildren<{
  initialActiveTab: string;
  fetchingData?: FetchingData;
}>;

export default function MultiStepForm({ initialActiveTab, children, fetchingData }: MultiStepFormProps) {
  const { windowInnerWidth } = useAppContext();

  const getTabDirection = () =>
    Breakpoints.s_tablet_portrait < windowInnerWidth ? Direction.VERTICAL : Direction.HORIZONTAL;

  return (
    <Tabs
      direction={getTabDirection()}
      initialActiveTab={initialActiveTab}
      hidingStrategy={HidingStrategy.CSS_ONLY}
      fetchingData={fetchingData}
    >
      {children}
    </Tabs>
  );
}
